import { Injectable } from '@angular/core';
import {
  HttpBackend,
  HttpClient,
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpHeaders,
  HttpInterceptor,
  HttpRequest,
  HttpResponse
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, shareReplay, switchMap, tap } from 'rxjs/operators';
import { matchRequestToMock } from 'protractor-api-mock-re-recorder/utils';
import { mapHttpResponseByMock, serializeRequest } from './utils';

@Injectable()
export class MockInterceptor implements HttpInterceptor {
  // list of cached scenarios
  private readonly scenarioCache: { [key: string]: Observable<any> } = {};

  private readonly httpClient: HttpClient;

  constructor(handler: HttpBackend) {
    this.httpClient = new HttpClient(handler);
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // TODO parametrize this condition
    if (request.url.match(/\.json$/) && request.url.match(/^\//)) {
      return next.handle(request);
    }

    return this.getScenarioConfig().pipe(
      switchMap(({ scenarioName, registeredMocks }) =>
        this.getScenarioMock(scenarioName).pipe(
          map((mocks: any[]) => {
            const match = matchRequestToMock(serializeRequest(request));
            return registeredMocks.find(match) || mocks.find(match);
          }),
          map((mock: any) => {
            if (!mock) {
              console.error('mock not found', request.url, JSON.stringify(serializeRequest(request)));
            }

            return mapHttpResponseByMock(mock);
          })
        )
      )
    );
  }

  private getScenarioMock(name: string): Observable<any[]> {
    if (!this.scenarioCache[name]) {
      this.scenarioCache[name] = this.request(name).pipe(shareReplay(1));
    }

    return this.scenarioCache[name];
  }

  private request(name) {
    return this.httpClient.get('/mocks/scenario/get?name=' + name);
  }

  private getScenarioConfig() {
    return this.httpClient.get<{ scenarioName: string; registeredMocks: {}[] }>('/mocks/scenario');
  }
}
